// SubAdminManagement.jsx
import React, { useContext, useEffect, useState } from 'react';
import {
  FiSearch,
  FiEdit,
  FiEye,
  FiTrash2,
  FiX,
  FiUser,
  FiMail,
  FiLock,
  FiCheckCircle,
  FiChevronLeft,
  FiChevronRight,
  FiPhone
} from 'react-icons/fi';
import '../../../assets/css/admin/dashboard/subadmins/subadmin.css';
import { Badge } from 'react-bootstrap';
import AppContext from 'context/AppContext';
import axios from 'axios';
import { Form } from 'react-router-dom';
import AdminMasterLayout from 'layouts/AdminMasterLayout';
import Swal from 'sweetalert2';

const SubAdmin = (loadAllAdmins) => {
  const { baseUrl, Navigate, regExpChecker,authToken } = useContext(AppContext);
  const [id, setId] = useState();
  const [fullName, setFullName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [status, setStatus] = useState();
  const [role, setRole] = useState();
  const [errors, setErrors] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [textForAddEdit, setTextForAddExit] = useState("Add");
  const [adminForEdit, setAdminForEdit] = useState(null);


  // const [admins, setAdmins] = useState([
  //   { id: 1, name: 'Ali Raza', email: 'exa@email.com', status: 'Active', avatar: 'AR' },
  //   { id: 2, name: 'Sara Khan', email: 'ann@email.com', status: 'Active', avatar: 'SK' },
  //   { id: 3, name: 'Hassan Malik', email: 'ann@email.com', status: 'Inactive', avatar: 'HM' },
  //   { id: 4, name: 'Ahmed Javed', email: 'aum@email.com', status: 'Inactive', avatar: 'AJ' },
  //   { id: 5, name: 'Lina Ashraf', email: 'izin@email.com', status: 'Deactive', avatar: 'LA' }
  // ]);
  const [subAdmins, setSubAdmins] = useState([]);

  const createSubAdmin = () => {
    setBtnLoading(true);
    console.log(email, password, fullName, role);
    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("status", status);
    // formData.append("role", role === "superadmin" ? true : false);
    formData.append("role", role);
    axios
      .post(`${baseUrl}/admin/auth/createSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
        handleCloseModal();
        setBtnLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setBtnLoading(false);
      });
  };
  const updateSubAdmin = () => {
    setBtnLoading(true);
    const formData = new FormData();
    formData.append("id", adminForEdit.id);
    // formData.append("id", admin.);
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("status", status);
    formData.append("role", role);
    axios
      .post(`${baseUrl}/admin/auth/updateSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log("resposne called", response.data);
        if (response.data.success == true) {
          setShowModal(false);
          viewAllSubAdmin();
          setTextForAddExit("Edit");
          if (response.data.success) {
            loadAllAdmins();
            setBtnLoading(false);
          }
          Swal.fire({
            title: 'Congrats!',
            text: 'Record Updated Successfuly',
            icon: 'success',
            confirmButtonText: 'Cool'
          });
        }
      })
      .catch((error) => {
        console.log(error);
        setBtnLoading(false);
      });
  };
  const deleteSubAdmin = (admin) => {
    const formData = new FormData();
    formData.append("id", admin.id);

    axios
      .post(`${baseUrl}/admin/auth/deleteSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const viewAllSubAdmin = () => {
    setTableLoading(true);
    axios
      .get(`${baseUrl}/admin/auth/viewAllSubAdmin`,{
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        }
      })
      .then((response) => {
        console.log(response.data.subAdmins);
        setSubAdmins(response.data.subAdmins);
        setTableLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setTableLoading(false);
      });
  };
  const handleEditAdmin = (admin) => {
    console.log("***********")
    console.log(admin)
    setAdminForEdit(admin.id);
    setTextForAddExit("Edit");
    setShowModal(true);
    setFullName(admin.fullName);
    setEmail(admin.email);
    setPhone(admin.phone);
    setPassword(admin.password);
    setStatus(admin.status);
    setRole(admin.role);
  }

  useEffect(() => {
    viewAllSubAdmin();
  }, []);

  const itemsPerPage = 40;
  const totalPages = Math.ceil(subAdmins.length / itemsPerPage);

  // Filtered Admins
  const filteredAdmins = subAdmins.filter(admin =>
    admin.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    admin.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Paginated Admins
  const paginatedAdmins = filteredAdmins.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  // // Handle Delete
  // const handleDelete = (id) => {
  //   const confirmed = window.confirm('Are you sure you want to delete this admin?');
  //   if (confirmed) {
  //     setSubAdmins(subAdmins.filter(admin => admin.id !== id));
  //     alert('Admin deleted successfully! ✅');
  //   }
  // };

  // Handle View
  const handleView = (admin) => {
    alert(`Viewing details of: ${admin.name}\nEmail: ${admin.email}\nStatus: ${admin.status}`);
  };

  // Handle Edit
  // Close Modal
  const handleCloseModal = () => {
    setShowModal(false);
    setFullName("");
    setEmail("");
    setPhone("");
    setPassword("");
    setStatus(false);

  };

  return (
    <AdminMasterLayout pageTitle='SubAdmin Management'>
      <div className="sub-admin-page">
        {/* Header */}
        

          <div className="sub-admin-header-right">
            <button
              className="sub-admin-add-admin-btn"
              onClick={() => {
                setShowModal(true);
                setTextForAddExit("Add");
              }}
            >
              Sub Admin
            </button>
          </div>
        

        {/* Stats 
      <div className="stats-info">
        Showing {paginatedAdmins.length} of {filteredAdmins.length} Sub Admins
      </div>*/}
        {/* Table */}
        <div className="sub-admin-table-container">
          <table className="sub-admin-table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Loading Admins...
                  </td>
                </tr>
              ) : paginatedAdmins.length > 0 ? (
                paginatedAdmins.map((admin) => (
                  <tr key={admin.id} className="sub-admin-table-row">
                    <td>{admin.id}</td>
                    <td>
                      <span className="sub-admin-name">
                        {admin.fullName}
                      </span>
                    </td>
                    <td>{admin.email}</td>
                    <td>{admin.phone}</td>
                    <td>
                      <Badge bg={admin.role === "superadmin" ? "success" : "secondary"}>
                        {admin.role === "superadmin"
                          ? "Super Admin"
                          : "Moderator"}
                      </Badge>
                    </td>
                    <td>
                      <Badge bg={admin.status === "Active" ? "success" : "secondary"}>
                        {admin.status}
                      </Badge>
                    </td>
                    <td>
                      <div className="sub-admin-action-buttons">
                        <button className="sub-admin-action-btn edit"
                          onClick={() => {
                            handleEditAdmin(admin);
                            updateSubAdmin(admin); setAdminForEdit(admin);
                          }} title="Edit"
                        >
                          <FiEdit />
                        </button> 
                        <button className="sub-admin-action-btn view" 
                        onClick={() => handleView(admin)} title="View" 
                        > <FiEye /> 
                        </button> 
                        <button className="sub-admin-action-btn delete" 
                        onClick={() => deleteSubAdmin(admin)}
                         title="Delete" > 
                        <FiTrash2 /> 
                        </button> 
                        </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No Admin Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="sub-admin-pagination">
          <span className="sub-admin-pagination-info">displaying page</span>

          <button
            className="sub-admin-pagination-btn"
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            <FiChevronLeft />
            Previous
          </button>

          <div className="sub-admin-page-numbers">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                className={`sub-admin-page-number ${currentPage === index + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>

          <button
            className="sub-admin-pagination-btn"
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            Next
            <FiChevronRight />
          </button>
        </div>

        {/* Add Admin Modal */}
        {showModal && (
          <>
            <div className="sub-admin-modal-overlay" ></div>
            <div className="sub-admin-modal-container">
              <div className="sub-admin-modal-header">
                <h2 className="sub-admin-modal-title">{textForAddEdit} Admin</h2>
                <button className="sub-admin-close-btn"
                  onClick={handleCloseModal}
                >
                  <FiX />
                </button>
              </div>
              {errors && (
                <div className='auth-seterrors'>
                  {errors}
                </div>
              )}

              <form className="sub-admin-modal-form">
                <div className="sub-admin-form-group">
                  <label className="sub-admin-form-label">Full Name</label>
                  <div className="sub-admin-input-wrapper">
                    <FiUser className="sub-admin-input-icon" />
                    <input
                      type="text"
                      placeholder="Enter full name"
                      value={fullName}
                      onChange={(event) => {
                        setFullName(event.target.value)
                        setErrors(regExpChecker("fullName", event.target.value))
                      }}
                      className="sub-admin-form-input"
                      required
                    />
                  </div>
                </div>

                <div className="sub-admin-form-group">
                  <label className="sub-admin-form-label">Email</label>
                  <div className="sub-admin-input-wrapper">
                    <FiMail className="sub-admin-input-icon" />
                    <input
                      type="email"
                      placeholder="exampleemail.com"
                      value={email}
                      disabled={textForAddEdit === "Edit"}
                      onChange={(event) => {
                        setEmail(event.target.value)
                        setErrors(regExpChecker("email", event.target.value))

                      }}
                      className="sub-admin-form-input"
                      required
                    />
                  </div>
                </div>
                <div className="sub-admin-form-group">
                  <label className="sub-admin-form-label">Phone</label>
                  <div className="sub-admin-input-wrapper">
                    <FiPhone className="sub-admin-input-icon" />
                    <input
                      type="phone"
                      placeholder="03xxxxxxxxx"
                      value={[phone]}
                      disabled={textForAddEdit === "Edit"}
                      onChange={(event) => {
                        setPhone(event.target.value)
                        setErrors(regExpChecker("phone", event.target.value))

                      }}
                      className="sub-admin-form-input"
                      required
                    />
                  </div>
                </div>
                {textForAddEdit == "Add" &&
                  <div className="sub-admin-form-group">
                    <label className="sub-admin-form-label">Password</label>
                    <div className="sub-admin-input-wrapper">
                      <FiLock className="sub-admin-input-icon" />
                      <input
                        type="password"
                        placeholder="••••••••••"
                        value={password}
                        onChange={(event) => {
                          setPassword(event.target.value)
                          setErrors(regExpChecker("password", event.target.value))
                        }}
                        className="sub-admin-form-input"
                        required
                      />
                    </div>
                  </div>
                }
                <div className="sub-admin-form-group">
                  <span className="sub-admin-form-label">Status:</span>
                  <div className="sub-toggle-wrap">
                    <label className={`sub-toggle ${status === 'Active' ? 'sub-toggle-on' : ''}`}>
                      <input
                        type="radio"
                        name="status"
                        value="Active"
                        checked={status === 'Active'}
                        onChange={() => setStatus('Active')}
                      />
                      <span className="sub-toggle-text">Active</span>
                    </label>

                    <label className={`sub-toggle ${status === 'Inactive' ? 'sub-toggle-on' : ''}`}>
                      <input
                        type="radio"
                        name="status"
                        value="Inactive"
                        checked={status === 'Inactive'}
                        onChange={() => setStatus('Inactive')}
                      />
                      <span className="sub-toggle-text">Inactive</span>
                    </label>
                  </div>
                </div>


                <div className="sub-admin-form-group sub-admin-checkbox-group">
                  <span className="sub-admin-form-label">Role:</span>
                  <label className="sub-admin-checkbox-label">
                    <input
                      type="radio"
                      name="role"
                      value="moderator"
                      checked={role === "moderator"}
                      onChange={() => setRole("moderator")}
                    />
                    Moderator
                  </label>

                  <label className="sub-admin-checkbox-label">
                    <input
                      type="radio"
                      name="role"
                      value="superadmin"
                      checked={role === "superadmin"}
                      onChange={() => setRole("superadmin")}
                    />
                    Super Admin
                  </label>
                </div>

                <div className="sub-admin-form-actions">
                  <button
                    type="button"
                    className="sub-admin-cancel-btn"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="sub-admin-submit-btn"
                    disabled={btnLoading}
                    onClick={textForAddEdit == "Add" ? createSubAdmin : updateSubAdmin}
                  >
                    {btnLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>

                        {textForAddEdit === "Add" ? "Adding..." : "Updating..."}
                      </>
                    ) : (
                      <>
                        <FiCheckCircle />
                        {textForAddEdit} Admin
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
      </div >
    </AdminMasterLayout>
  );
};

export default SubAdmin;